import { render, staticRenderFns } from "./component.vue?vue&type=template&id=43ef37b2&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=43ef37b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ef37b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43ef37b2')) {
      api.createRecord('43ef37b2', component.options)
    } else {
      api.reload('43ef37b2', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=43ef37b2&scoped=true&", function () {
      api.rerender('43ef37b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/secure/resource/component/marketing-preference/component.vue"
export default component.exports